export enum Space {
  Main = 'main',
  Folder = 'folder',
  Mission = 'mission',
  SubMission = 'subMission',
  MasterData = 'masterData',
  References = 'references',
  Admin = 'admin',
}
